/** m:ss for a whole number of seconds: 9:05 for 545 (D-077's join request countdowns). */
export function formatCountdown(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
